import '../App.css';
import '../scss/App.scss';
import { Box, Container, Grid, Link } from '@mui/material';
import React, { useState } from 'react';
import Content from '../layout/content-box/Content';
import SEO from '../seo/SEO';

function Career() {


  return (
    <>
      <SEO pageKey="career" />
      <Box className="aboutBanner contactBanner" >
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="left" alignItems="center">
            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="bannerText text-center">
                <h1>{Content[0].careerHeading}</h1>
                <span>Your Career, Our Commitment — Discover opportunities where innovation meets purpose,  and every step forward is supported.</span>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>

      <section className="founderBox">
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="left" alignItems="center">

            <Grid size={{ xl: 7, lg: 7, md: 7, sm: 12, xs: 12 }} >
              <Box className="founderDesc">
                <h2 className='tealColor'>About Us</h2>
                <p><span className="fontWeight">Arixpower India Pvt. Ltd.</span> is building Mandirwiki – a one-of-its-kind tech platform modernizing pilgrimage tourism across India. From IoT-enabled Smart Lockers to AI-powered crowd management, VR Darshan, and our upcoming Pilgrimage App, we’re on a mission to make pilgrim journeys more convenient, connected, and memorable.</p>
                <p>We work with some of India’s most respected temples, government bodies, and travel hubs.</p>
              </Box>
            </Grid>

            <Grid size={{ xl: 1, lg: 1, md: 1, sm: 12, xs: 12 }} >

            </Grid>

            <Grid size={{ xl: 4, lg: 4, md: 4, sm: 12, xs: 12 }} >
              <Box className="founderImage">
                <img src="/assets/guide-demo.svg" className='img-fluid' />
              </Box>
            </Grid>
          </Grid>
        </Container>
      </section>

      <section className="cta">
        <Container maxWidth="md">
          <Grid container spacing={2} justifyContent="left">

            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >
              <Box className="founderDesc text-center">
                <h2 >We currently have 19 openings. We're hiring for our Delhi office as well as remote locations across India.</h2>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </section>


      <section className="openings">
        <Container maxWidth="xl">
          <Grid container spacing={2} justifyContent="left">

            <Grid size={{ xl: 12, lg: 12, md: 12, sm: 12, xs: 12 }} >


              <Box>
                <div className="custom-tabs-container">
                  <ul className="nav nav-tabs custom-tabs" id="myTab" role="tablist">
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link active  custom-tab-link text-center"
                        id="home-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#home"
                        type="button"
                        role="tab"
                        aria-controls="home"
                        aria-selected="true"
                      >
                        Operations Executive
                      </button>
                    </li>
                    
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link custom-tab-link text-center"
                        id="contact-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#contact"
                        type="button"
                        role="tab"
                        aria-controls="contact"
                        aria-selected="false"
                      >
                        IT
                      </button>
                    </li>

                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link custom-tab-link text-center"
                        id="fa-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#fa"
                        type="button"
                        role="tab"
                        aria-controls="fa"
                        aria-selected="false"
                      >
                        F&A
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link custom-tab-link text-center"
                        id="creative-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#creative"
                        type="button"
                        role="tab"
                        aria-controls="creative"
                        aria-selected="false"
                      >
                        Creative
                      </button>
                    </li>

                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link custom-tab-link text-center"
                        id="bde-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#bde"
                        type="button"
                        role="tab"
                        aria-controls="bde"
                        aria-selected="false"
                      >
                        Business Development
                      </button>
                    </li>
                    <li className="nav-item" role="presentation">
                      <button
                        className="nav-link custom-tab-link text-center"
                        id="writer-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#writer"
                        type="button"
                        role="tab"
                        aria-controls="writer"
                        aria-selected="false"
                      >
                        Content writer
                      </button>
                    </li>

                    
                  </ul>

                  <div className="tab-content custom-tab-content" id="myTabContent">
                    <div
                      className="tab-pane fade show active custom-tab-pane"
                      id="home"
                      role="tabpanel"
                      aria-labelledby="home-tab"
                    >

                      


                       <Box className="templeInnerHeading mt-5 ">
                        <h2 className='tealColor'>Operations Executive</h2>
                        <div className='openingDetails mt-3'>
                          <h6 className="experience"><strong><i className="fa fa-briefcase"></i></strong> Full-Time</h6>
                          <h6 className="experience"> ₹15K–₹20K/month, 6 Days a week</h6>
                          <h6 className="location"><strong><i className="fa fa-map-marker"></i></strong> Katra, J&K </h6>
                        </div>
                      </Box>
                      <Box className="openingBox mt-4">
                        <h3>About the Role</h3>
                        <p>As an <span className='fontWeight'>Operations Executive,</span> you’ll be the go-to person for managing day-to-day smart locker operations at our Katra center. From handling <span className='fontWeight'>locker bookings, check-ins, and checkouts</span> to guiding devotees through <span className='fontWeight'>WhatsApp and chatbot-based bookings,</span> you’ll ensure a smooth and hassle-free experience for every visitor.</p>

                        <h3>Key Responsibilities</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>Booking Assistance –</span> Help devotees book lockers via WhatsApp, chatbot, or walk-ins.</li>
                              <li><span>Check-in & Checkout –</span> Manage the locker allotment process, issue receipts/tickets, and ensure proper check-out procedure.</li>
                              <li><span>Ticket Printing & Handover –</span> Print and hand over booking tickets to customers, ensuring details are correct.</li>
                              <li><span>Customer Support –</span> Assist devotees in understanding how to use lockers and answer their queries patiently.</li>
                              <li><span>System & Payment Handling –</span> Operate booking software, process payments, and reconcile daily transactions.</li>
                              <li><span>Troubleshooting –</span> Coordinate with the technical team for any locker or system issues.</li>
                              <li><span>Record Keeping –</span> Maintain daily footfall, booking, and payment records.</li>
                              <li><span>On-Ground Assistance –</span> Guide customers in case of booking errors or payment-related concerns.</li>
                              <li><span>Cleanliness & Upkeep –</span> Ensure lockers and the booking counter are always clean, organized, and operational.</li>
                              <li><span>Crowd Management Support –</span> Assist in managing queues during peak hours to maintain order and efficiency.</li>

                            </ul>
                          </div>
                        </div>

                        <h3>Requirements</h3>

                        <div className="listCheck">
                          <ul>
                            <li><span>✔ -</span> Tech-friendly and comfortable using booking systems (training provided).</li>
                            <li><span>✔ -</span> Polite, well-groomed, and customer-focused.</li>
                            <li><span>✔ -</span> Strong communication skills in Hindi and basic English.</li>
                            <li><span>✔ -</span> Ability to remain calm under pressure during rush hours.</li>
                            <li><span>✔ -</span> Basic computer knowledge for record management.</li>
                            <li><span>✔ -</span> Willingness to work flexible hours, including weekends and holidays.</li>

                          </ul>
                        </div>

                        <h3>Why Join Us?</h3>
                        <div className='infoGuideBox pt-0'>
                          <div className="infoList">
                            <ul>
                              <li>Be part of an innovative IoT-based pilgrimage service.</li>
                              <li>Work in a role where technology meets customer experience.</li>
                              <li>Grow with a fast-expanding brand bringing smart lockers to major pilgrimage sites across India.</li>
                            </ul>
                          </div>
                        </div>
                        

                        <p>📩 <span className='fontWeight'>How to Apply:</span> Send your <span className='fontWeight'>résumé</span> to <span className='fontWeight'><a href="mailto:careers@mandir.wiki">careers@mandir.wiki</a></span> with the subject: <span className='fontWeight'>Résumé</span> – Operations Executive (Katra).</p>
                        <a href="mailto:careers@mandir.wiki?Operations Executive" className='outlineButton'>Apply Now</a>

                      </Box>



<Box className="templeInnerHeading mt-5 ">
                        <h2 className='tealColor'>Assistant Manager – Operations</h2>
                        <div className='openingDetails mt-3'>
                          <h6 className="experience"><strong><i className="fa fa-briefcase"></i></strong> Full-Time</h6>
                          <h6 className="experience"> ₹20K–₹30K/month, 6 Days a week</h6>
                          <h6 className="location"><strong><i className="fa fa-map-marker"></i></strong> Katra, Jammu </h6>
                        </div>
                      </Box>
                      <Box className="openingBox mt-4">
                        <h3>About the Role</h3>
                        <p>We’re seeking an <span className='fontWeight'>experienced and people-focused Lead</span> to manage daily operations at our Katra center. You’ll lead a <span className='fontWeight'>15–20-member team, prepare rosters, manage shifts and leaves, and ensure seamless operations under the heavy daily footfall of 30,000–50,000 visitors.</span> This role also involves <span className='fontWeight'>working closely with government officials and bureaucrats in day-to-day operations</span> and implementing effective <span className='fontWeight'>crowd management strategies.</span> The ideal candidate will also possess <span className='fontWeight'>marketing skills, technology awareness, and proficiency with Android devices, internet usage, and troubleshooting.</span></p>

                        <h3>Key Responsibilities</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>Efficient Crowd Management</span>
                                <ul>
                                  <li>Plan and execute crowd control measures during peak hours and events.</li>
                                  <li>Coordinate with security, government agencies, and internal teams for safe movement of visitors.</li>
                                  <li>Train staff on crowd handling and emergency procedures.</li>
                                </ul>
                              </li>

                              <li><span>Deliver Excellent Customer Service</span>
                                <ul>
                                  <li>Handle queries and resolve concerns promptly with a polite, professional approach.</li>
                                  <li>Maintain a welcoming environment for all visitors.</li>
                                </ul>
                              </li>

                              <li><span>Marketing, Promotions & Events</span>
                                <ul>
                                  <li>Use marketing skills to promote services locally.</li>
                                  <li>Coordinate promotional activities and events with the marketing team.</li>
                                  <li>Support seasonal campaigns to boost footfall and awareness.</li>
                                </ul>
                              </li>

                              <li><span>Inventory Management</span>
                                <ul>
                                  <li>Monitor stock levels, track movement, and prevent losses.</li>
                                  <li>Ensure timely procurement and accurate stock reporting.</li>
                                </ul>
                              </li>

                              <li><span>Technology & Troubleshooting</span>
                                <ul>
                                  <li>Be proficient with Android-based devices and internet handling.</li>
                                  <li>Troubleshoot basic technical issues related to devices and operations.</li>
                                  <li>Train staff on technology usage for daily tasks.</li>
                                </ul>
                              </li>



                              <li><span>Performance & Reporting</span>
                                <ul>
                                  <li>Track KPIs, suggest operational improvements, and report updates to senior management.</li>
                                  <li>Align center activities with overall company goals.</li>
                                </ul>
                              </li>

                            </ul>
                          </div>
                        </div>

                        <h3>What We’re Looking For</h3>

                        <div className="listCheck">
                          <ul>
                            <li><span>✔ -</span> 3–5 years’ experience in store operations, retail, inventory, or center management.</li>
                            <li><span>✔ -</span> Proven experience managing a team of 15–20 members.</li>
                            <li><span>✔ -</span> Strong communication, leadership, and marketing skills.</li>
                            <li><span>✔ -</span> Technology-aware with proficiency in Android devices, internet usage, and troubleshooting.</li>
                            <li><span>✔ -</span> Experience working with government officials and bureaucrats. (Not Mandatory)</li>
                            <li><span>✔ -</span> Expertise in crowd management for high-footfall environments.</li>
                            <li><span>✔ -</span> Experience preparing rosters, managing shifts, and approving leaves.</li>
                            <li><span>✔ -</span> Ability to perform under heavy daily footfall of 30K–50K visitors.</li>
                            <li><span>✔ -</span> Polite, customer-oriented, and able to resolve issues effectively.</li>
                            <li><span>✔ -</span> Graduate in any stream (MBA/PG in Operations is an advantage).</li>

                          </ul>
                        </div>

                        <h3>Why Join Us?</h3>
                        <div className='infoGuideBox pt-0'>
                          <div className="infoList">
                            <ul>
                              <li>A role that blends leadership, operations, marketing, and crowd management.</li>
                              <li>Be part of a mission-driven company changing the way people experience spirituality.</li>
                              <li>Grow your career in a supportive, fast-paced environment.</li>

                            </ul>
                          </div>
                        </div>
                        

                        <p>📩 <span className='fontWeight'>How to Apply:</span> Send your <span className='fontWeight'>résumé</span> to <span className='fontWeight'><a href="mailto:careers@mandir.wiki">careers@mandir.wiki</a></span> with the subject line: “Assistant Manager – Operations Katra”.</p>
                        <a href="mailto:careers@mandir.wiki?Assistant Manager – Operations Katra" className='outlineButton'>Apply Now</a>

                      </Box>















































                    </div>
                    
                    <div
                      className="tab-pane fade custom-tab-pane"
                      id="contact"
                      role="tabpanel"
                      aria-labelledby="contact-tab"
                    >
                      <Box className="templeInnerHeading mt-5 ">
                        <h2 className='tealColor'>Social Media Manager</h2>
                        <div className='openingDetails mt-3'>
                          <h6 className="experience"><strong><i className="fa fa-briefcase"></i></strong> Remote – 5 Days/Week</h6>
                          <h6 className="experience"> ₹30K–₹50K/month, 6 Days a week</h6>
                          <h6 className="location"><strong><i className="fa fa-map-marker"></i></strong> Delhi  </h6>
                        </div>
                      </Box>
                      <Box className="openingBox mt-4">
                        <h3>About the Role</h3>
                        <p className='mb-2'><span className='fontWeight'>🚫 Don’t apply :</span> If you don’t actively create content on your social media and can’t share a personal portfolio, this role is not for you. We want creators who live and breathe content.</p>

                        <h3>Your Role & Impact</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>Grow & Engage Communities –</span> Rapidly scale followers and boost engagement on Instagram, YouTube, and more with innovative campaigns.</li>
                              <li><span>Create Scroll-Stopping Content –</span> Produce Reels, short videos, and posts that are culturally rich and instantly shareable.</li>
                              <li><span>Own the Content Lifecycle –</span> From idea to script to shoot to publish, you’ll ensure every post reflects top-tier quality.</li>
                              <li><span>Leverage AI Tools –</span> Use platforms like Runway, Midjourney, Pika, and Synthesia to add a creative edge.</li>
                              <li><span>Analyze & Adapt –</span> Track performance metrics, identify trends, and fine-tune strategies for maximum reach.</li>
                              <li><span>Stay Relevant –</span> Maintain a content calendar synced with festivals, events, and brand milestones.</li>
                              <li><span>Be the Community Pulse –</span> Engage in DMs, comments, and user-generated content to nurture a loyal audience.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>What We’re Looking For</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>Experience:</span> 3+ years in social media management with proven growth results.</li>
                              <li><span>Portfolio:</span> Active personal accounts showcasing your content with strong engagement.</li>
                              <li><span>Video Mastery:</span> Skilled in creating, editing, and storytelling for short-form video.</li>
                              <li><span>Cultural Sensitivity:</span> Deep understanding of Indian festivals, traditions, and spiritual culture.</li>
                              <li><span>Storyteller’s Mindset:</span> Ability to craft content that moves hearts and minds.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>Bonus Points For</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li>Experience in a startup environment and brand-building from the ground up.</li>
                              <li>Passion for temples, heritage, and spirituality.</li>
                              <li>Background in performance marketing campaigns.</li>
                            </ul>
                          </div>
                        </div>

                        <h3>Why You’ll Love It Here</h3>

                        <div className="listCheck">
                          <ul>
                            <li><span>✔ –</span> Blend tradition with innovation in every piece of content.</li>
                            <li><span>✔ –</span> Enjoy creative freedom while making an impact on a purpose-driven brand.</li>
                            <li><span>✔ </span> Be part of a fast-growing company with a one-of-a-kind niche.</li>

                          </ul>
                        </div>


                        

                        <p>📩 <span className='fontWeight'>How to Apply:</span> Send your <span className='fontWeight'>résumé</span> and <span className='fontWeight'>links to your social profiles & portfolio </span> to <span className='fontWeight'><a href="mailto:careers@mandir.wiki">careers@mandir.wiki</a></span> with the subject: <span className='fontWeight'>Résumé – Social Media Manager.</span> </p>
                        <a href="mailto:careers@mandir.wiki?Social Media Manager"  className='outlineButton'>Apply Now</a>

                      </Box>

                      <Box className="templeInnerHeading mt-5 ">
                        <h2 className='tealColor'>Performance Marketer & E-commerce Manager</h2>
                        <div className='openingDetails mt-3'>
                          <h6 className="experience"><strong><i className="fa fa-laptop"></i></strong> Remote – 6 Days a week  </h6>
                          <h6 className="location"><strong><i className="fa fa-map-marker"></i></strong> New Delhi   </h6>
                        </div>
                      </Box>
                      <Box className="openingBox mt-4">
                        <h3>About the Role</h3>
                        <h6 className='mt-3'>Who This Role is For</h6>
                        <p className='mb-2'>This is a <span className='fontWeight'>high-ownership role</span> where you’ll manage serious budgets, execute high-impact campaigns, and directly influence both revenue and brand growth. If you’ve built and scaled <span className='fontWeight'>B2C performance marketing channels with ₹10+ lakh monthly budgets,</span> and you’re from a <span className='fontWeight'>Tier-1 institute (IIT, IIM,),</span> we should talk.</p>
                        <p className='mb-2'>🚫 <span className='fontWeight'>Don’t apply if</span> you don’t meet both criteria. We’re looking for someone who can hit the ground running from day one.</p>

                        <h3>What You’ll Do</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>Performance Marketing Leadership –</span> Take complete ownership of paid acquisition campaigns across Google Ads, Meta, LinkedIn, and other high-impact channels.</li>
                              <li><span>E-commerce Growth Management –</span> Strategize, optimize, and scale sales on Shopify, Amazon, Flipkart, and Mandirwiki marketplace with tailored approaches for each.</li>
                              <li><span>Budget & ROI Accountability –</span> Oversee substantial monthly budgets, maximizing the impact of every rupee by optimizing for Cost per Acquisition (CPA), Return on Ad Spend (ROAS), and Customer Lifetime Value (LTV).</li>
                              <li><span>Data-Driven Experimentation –</span> Run A/B tests, deep-dive into performance analytics, and constantly fine-tune for higher conversions.</li>
                              <li><span>Full-Funnel Strategy Execution –</span> Work closely with design, content, and product teams to create ad creatives, landing pages, and user journeys that convert.</li>
                              <li><span>Analytics & Reporting –</span> Build robust reporting dashboards, share key insights, and recommend next steps to leadership.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>What You Bring</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>Education:</span> Degree from a Tier-1 institute (IIT, IIM, NIT, or equivalent).</li>
                              <li><span>Experience:</span> 3+ years of performance/digital marketing in a high-growth B2C, E-commerce, or OTT environment.</li>
                              <li><span>Tools Mastery:</span> Deep knowledge of Google Ads, Meta Ads, and advanced tracking/attribution models.</li>
                              <li><span>Analytical Mindset:</span> Comfort working with large datasets, identifying trends, and making fast, informed decisions.</li>
                            </ul>
                          </div>
                        </div>

                        <h3>Bonus Points If You Have</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li>0-to-1 startup experience with the ability to build processes from scratch.</li>
                              <li>Exposure to marketing automation platforms.</li>
                              <li>Curiosity and passion for emerging tech like AR/VR.</li>
                            </ul>
                          </div>
                        </div>

                        <h3>Why This Role Rocks</h3>

                        <div className="listCheck">
                          <ul>
                            <li>You’ll manage big budgets with absolute autonomy.</li>
                            <li>You’ll directly shape the growth trajectory of a fast-scaling brand.</li>
                            <li>You’ll get to blend e-commerce, performance marketing, and tech innovation in one role.</li>
                          </ul>
                        </div>


                        

                        <p>📩 <span className='fontWeight'>How to Apply:</span> Send your <span className='fontWeight'>résumé</span> to <span className='fontWeight'>résumé</span> to <span className='fontWeight'><a href="mailto:careers@mandir.wiki">careers@mandir.wiki</a></span> with the subject: <span className='fontWeight'>Résumé</span> – Performance Marketer & E-commerce Manager.</p>
                        <a href="mailto:careers@mandir.wiki?Performance Marketer & E-commerce Manager" className='outlineButton'>Apply Now</a>

                      </Box>

                      <Box className="templeInnerHeading mt-5 ">
                        <h2 className='tealColor'>Graphic Designer</h2>
                        <div className='openingDetails mt-3'>
                          <h6 className="experience"><strong><i className="fa fa-map-marker"></i></strong> Delhi  </h6>
                          <h6 className="location"> ₹20K/month, 6 Days a week   </h6>
                        </div>
                      </Box>
                      <Box className="openingBox mt-4">

                        <h3>About the Role</h3>
                        <h6 className='mt-3'>Who This Role is For</h6>
                        <p className='mb-2'>We’re on the lookout for a <span className='fontWeight'>Graphic Designer</span> with <span className='fontWeight'>2+ years of professional experience</span> who can transform ideas into impactful visual stories. You’ll be responsible for creating designs that are not only visually appealing but also communicate our brand’s message clearly and creatively. If you have a keen eye for detail, thrive in a collaborative environment, and love experimenting with the latest design tools (including AI), this role is for you.</p>

                        <h3>What You’ll Do</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li>Work closely with our content and marketing teams to understand audience needs and project objectives.</li>
                              <li>Create engaging graphics for social media, websites, marketing campaigns, presentations, and other brand assets.</li>
                              <li>Use AI-based design tools like Midjourney or Adobe Firefly to bring fresh ideas to life.</li>
                              <li>Refine designs based on constructive feedback, ensuring quality and consistency in every project.</li>
                              <li>Stay up to date with design trends, emerging tools, and creative techniques.</li>
                              <li>Translate complex concepts into simple, clear, and visually attractive designs.</li>
                              <li>Maintain a consistent brand style, tone, and visual identity across all creative outputs.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>What We’re Looking For</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li>Minimum 2 years of hands-on design experience.</li>
                              <li>A portfolio that showcases your strongest and most creative work (mandatory).</li>
                              <li>Mastery of Adobe Photoshop and Adobe Illustrator.</li>
                              <li>Proficiency in AI-driven design platforms (Midjourney, Adobe Firefly, etc.).</li>
                              <li>Strong grasp of typography, color theory, composition, and visual storytelling.</li>
                              <li>A positive, collaborative attitude and excellent communication skills.</li>
                            </ul>
                          </div>
                        </div>

                        <h3>Bonus Points If You Have</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li>Skills in motion graphics, video editing, or Figma.</li>
                              <li>A degree from NID, NIFT, or other Tier-1 design institutes.</li>
                              <li>Experience working in a startup or high-paced creative environment.</li>
                            </ul>
                          </div>
                        </div>



                        

                        <p>📩 <span className='fontWeight'>How to Apply:</span> Send your <span className='fontWeight'>résumé</span> and portfolio link to <span className='fontWeight'><a href="mailto:careers@mandir.wiki">careers@mandir.wiki</a></span> with the subject line: <span className='fontWeight'>Résumé</span> –Graphic Designer.</p>
                        <a href="mailto:careers@mandir.wiki?Graphic designer"  className='outlineButton'>Apply Now</a>

                      </Box>

                      <Box className="templeInnerHeading mt-5 ">
                        <h2 className='tealColor'>Flutter Developer</h2>

                         <div className='openingDetails mt-3'>
                          <h6 className="experience"><strong>Experience</strong> 2+ Years</h6>
                          <h6 className="experience"><strong><i className="fa fa-briefcase"></i></strong> Full-Time</h6>
                          <h6 className="experience"><strong><i className="fa fa-inr"></i></strong> 50,000/month, 6 Days a week</h6>
                          <h6 className="location"><strong><i className="fa fa-map-marker"></i></strong> Delhi </h6>
                        </div>
                      </Box>
                      <Box className="openingBox mt-4">
                        <h3>About the Role</h3>
                        <p className='mb-2'>We’re looking for a <span className='fontWeight'>Flutter Developer</span> with a passion for crafting high-performance, visually stunning, and user-friendly mobile applications. In this role, you’ll work on <span className='fontWeight'>both Android and iOS</span> platforms, contributing to user-facing features, enhancing performance, and collaborating with designers, backend engineers, and QA teams to deliver a seamless app experience.</p>

                        <h3>What You’ll Do</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>Build Cross-Platform Apps –</span> Develop and maintain mobile applications using Flutter & Dart.</li>
                              <li><span>Write Quality Code –</span> Implement clean, scalable, and well-documented codebases.</li>
                              <li><span>Integrate APIs & Services –</span> Work with REST APIs and third-party integrations.</li>
                              <li><span>Deliver Pixel-Perfect UI –</span> Collaborate with UI/UX designers to ensure flawless interfaces.</li>
                              <li><span>Optimize Performance –</span> Ensure apps are responsive, stable, and optimized for both Android and iOS.</li>
                              <li><span>Collaborate in Agile Sprints –</span> Participate in code reviews, sprint planning, and release cycles.</li>
                              <li><span>Debug & Maintain –</span> Identify and fix bugs, optimize code, and maintain app stability.</li>
                              <li><span>Cross-Team Coordination –</span> Work closely with backend, QA, and DevOps for smooth delivery.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>What We’re Looking For</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>Experience –</span> 2+ years of hands-on Flutter development.</li>
                              <li><span>State Management Skills –</span> Proficiency with Provider, Riverpod, Bloc.</li>
                              <li><span>Integration Expertise –</span> Experience with APIs,  local storage, and native device features (camera, GPS, push notifications, SDK etc.).</li>
                              <li><span>Technical Knowledge –</span> Git, REST APIs, and asynchronous programming in Dart.</li>
                              <li><span>Deployment Skills –</span> Familiarity with Play Store & App Store publishing workflows.</li>
                              <li><span>Soft Skills –</span> Strong problem-solving abilities and clear communication.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>Bonus Points</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li>Experience with native Android (Java/Kotlin) or iOS (Swift/Objective-C).</li>
                              <li>Familiarity with CI/CD tools like Codemagic, Bitrise, or GitHub Actions.</li>
                              <li>Knowledge of performance monitoring, analytics, and crash reporting tools.</li>
                              <li>Previous work on fintech, tour and travel, or high-traffic mobile apps.</li>
                            </ul>
                          </div>
                        </div>


                       

                        <p>Send your <span className='fontWeight'>résumé</span> and <span className='fontWeight'>portfolio/GitHub</span> to <span className='fontWeight'><a href="mailto:careers@mandir.wiki">careers@mandir.wiki</a></span> with the subject line: <span className='fontWeight'>Résumé – Flutter Developer</span></p>
                        <a href="mailto:careers@mandir.wiki?Flutter Developer"  className='outlineButton'>Apply Now</a>

                      </Box>

                      <Box className="templeInnerHeading mt-5 ">
                        <h2 className='tealColor'>Flutter Intern</h2>
                        <div className='openingDetails mt-3'>
                          <h6 className="experience"><strong>Experience</strong> 0-1+ Years</h6>
                          <h6 className="experience"><strong><i className="fa fa-briefcase"></i></strong> Full-Time</h6>
                          <h6 className="experience"><strong><i className="fa fa-inr"></i></strong> 20,000/month, 6 Days a week</h6>
                          <h6 className="location"><strong><i className="fa fa-map-marker"></i></strong> Delhi </h6>
                        </div>
                      </Box>
                      <Box className="openingBox mt-4">
                        <h3>About the Role</h3>
                        <p className='mb-2'>We’re looking for a <span className='fontWeight'>Flutter Intern</span> with a passion for crafting high-performance, visually stunning, and user-friendly mobile applications. In this role, you’ll work on <span className='fontWeight'>both Android and</span> iOS platforms, contributing to user-facing features, enhancing performance, and collaborating with designers, backend engineers, and QA teams to deliver a seamless app experience.</p>

                        <h3>What You’ll Do</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>Build Cross-Platform Apps –</span> Develop and maintain mobile applications using Flutter & Dart.</li>
                              <li><span>Write Quality Code –</span> Implement clean, scalable, and well-documented codebases.</li>
                              <li><span>Integrate APIs & Services –</span> Work with REST APIs and third-party integrations.</li>
                              <li><span>Deliver Pixel-Perfect UI –</span> Collaborate with UI/UX designers to ensure flawless interfaces.</li>
                              <li><span>Optimize Performance –</span> Ensure apps are responsive, stable, and optimized for both Android and iOS.</li>
                              <li><span>Collaborate in Agile Sprints –</span> Participate in code reviews, sprint planning, and release cycles.</li>
                              <li><span>Debug & Maintain –</span> Identify and fix bugs, optimize code, and maintain app stability.</li>
                              <li><span>Cross-Team Coordination –</span> Work closely with backend, QA, and DevOps for smooth delivery.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>What We’re Looking For</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>Experience –</span> 0-1 year of hands-on Flutter development.</li>
                              <li><span>State Management Skills –</span> Proficiency with Provider, Riverpod, Bloc.</li>
                              <li><span>Integration Expertise –</span> Experience with APIs,  local storage, and native device features (camera, GPS, push notifications, SDK etc.).</li>
                              <li><span>Technical Knowledge –</span> Git, REST APIs, and asynchronous programming in Dart.</li>
                              <li><span>Deployment Skills –</span> Familiarity with Play Store & App Store publishing workflows.</li>
                              <li><span>Soft Skills –</span> Strong problem-solving abilities and clear communication.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>Bonus Points</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li>Experience with native Android (Java/Kotlin) or iOS (Swift/Objective-C).</li>
                              <li>Familiarity with CI/CD tools like Codemagic, Bitrise, or GitHub Actions.</li>
                              <li>Knowledge of performance monitoring, analytics, and crash reporting tools.</li>
                              <li>Previous work on fintech, tour and travel, or high-traffic mobile apps.</li>
                            </ul>
                          </div>
                        </div>


                        

                        <p>📩 <span className='fontWeight'>How to Apply:</span> Send your <span className='fontWeight'>résumé</span> and <span className='fontWeight'>portfolio/GitHub</span> to <span className='fontWeight'><a href="mailto:careers@mandir.wiki">careers@mandir.wiki</a></span> with the subject line: <span className='fontWeight'>Résumé – Flutter Intern</span></p>
                        <a href="mailto:careers@mandir.wiki?Flutter Intern"  className='outlineButton'>Apply Now</a>

                      </Box>
                      <Box className="templeInnerHeading mt-5 ">
                        <h2 className='tealColor'>Backend Developer (Node.js)</h2>

                        <div className='openingDetails mt-3'>
                          <h6 className="experience"><strong>Experience</strong> 2+ Years</h6>
                          <h6 className="experience"><strong><i className="fa fa-briefcase"></i></strong> Full-Time </h6>
                          <h6 className="experience"><strong><i className="fa fa-inr"></i></strong> 50,000/month, 6 Days a week</h6>
                          <h6 className="location"><strong><i className="fa fa-map-marker"></i></strong> Delhi </h6>
                        </div>
                      </Box>
                      
                      <Box className="openingBox mt-4">
                        <h3>About the Role</h3>
                        <p className='mb-2'>We are looking for a <span className='fontWeight'>skilled Backend Developer</span> with solid expertise in <span className='fontWeight'>Node.js</span> to join our growing team. You will design, develop, and maintain backend systems that power our web and mobile applications, ensuring they are <span className='fontWeight'>scalable, secure, and high-performing.</span></p>
                        <p className='mb-2'>You’ll work closely with <span className='fontWeight'>frontend developers, product managers, and other stakeholders</span> to turn requirements into robust technical solutions while staying up-to-date with modern backend practices.</p>

                        <h3>Responsibilities</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>Develop & Maintain APIs –</span> Build backend services and RESTful APIs using Node.js.</li>
                              <li><span>Write Efficient Code –</span> Create reusable, reliable, and maintainable backend components.</li>
                              <li><span>Integrate with Frontend –</span> Collaborate with frontend developers to ensure smooth integration of UI and backend logic.</li>
                              <li><span>Optimize Performance –</span> Improve application speed, scalability, and security.</li>
                              <li><span>Ensure Quality –</span> Implement automated testing, debugging, and continuous integration workflows.</li>
                              <li><span>Collaborate with Product Teams –</span> Understand business requirements and translate them into technical deliverables.</li>
                              <li><span>Participate in Code Reviews –</span> Share feedback and maintain high coding standards.</li>
                              <li><span>Troubleshoot & Resolve Issues –</span> Diagnose problems, perform root cause analysis, and implement fixes.</li>
                              <li><span>Stay Current –</span> Keep up with emerging backend technologies and best practices.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>Requirements</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>Experience –</span> Minimum 2 years as a Backend Developer with Node.js.</li>
                              <li><span>Technical Skills –</span> Strong proficiency in JavaScript and Node.js frameworks (Express.js, Nest.js).</li>
                              <li><span>Database Knowledge –</span> Experience with MongoDB, MySQL, or PostgreSQL.</li>
                              <li><span>API Expertise –</span> Solid understanding of REST API design principles.</li>
                              <li><span>Architecture Skills –</span> Understanding of asynchronous programming and event-driven systems.</li>
                              <li><span>Collaboration Tools –</span> Proficiency with Git and collaborative workflows.</li>
                              <li><span>Soft Skills –</span> Strong problem-solving abilities, attention to detail, and clear communication.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>Preferred Qualifications</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li>Experience with cloud platforms (AWS, Azure, GCP).</li>
                              <li>Knowledge of containerization (Docker) and orchestration (Kubernetes).</li>
                              <li>Familiarity with DevOps practices and CI/CD pipelines.</li>
                              <li>Experience with GraphQL.</li>
                              <li>Open-source contributions or a strong GitHub portfolio.</li>
                            </ul>
                          </div>
                        </div>


                        

                        <p>📩 <span className='fontWeight'>How to Apply:</span> Send your <span className='fontWeight'>résumé</span> and <span className='fontWeight'>portfolio/GitHub profile</span> to <span className='fontWeight'><a href="mailto:careers@mandir.wiki">careers@mandir.wiki</a></span> with the subject line: <span className='fontWeight'>résumé – Backend Developer (Node.js)</span></p>
                        <a href="mailto:careers@mandir.wiki?Backend Developer (Node.js)" className='outlineButton'>Apply Now</a>

                      </Box>

                      <Box className="templeInnerHeading mt-5 ">
                        <h2 className='tealColor'>Backend Developer (Node.js) Intern</h2>
                        <div className='openingDetails mt-3'>
                          <h6 className="experience"><strong>Experience</strong> 0-1 Years</h6>
                          <h6 className="experience"><strong><i className="fa fa-laptop"></i></strong> Remote  Full-Time </h6>
                          <h6 className="experience"><strong><i className="fa fa-inr"></i></strong> 20,000/month, 6 Days a week</h6>
                          <h6 className="location"><strong><i className="fa fa-map-marker"></i></strong> Delhi </h6>
                        </div>
                      </Box>
                      <Box className="openingBox mt-4">
                        <h3>About the Role</h3>
                        <p className='mb-2'>We are looking for a <span className='fontWeight'>skilled Backend Developer</span> with solid expertise in <span className='fontWeight'>Node.js</span> to join our growing team. You will design, develop, and maintain backend systems that power our web and mobile applications, ensuring they are scalable, secure, and high-performing.</p>
                        <p className='mb-2'>You’ll work closely with <span className='fontWeight'>frontend developers, product managers, and other stakeholders</span> to turn requirements into robust technical solutions while staying up-to-date with modern backend practices.</p>

                        <h3>Responsibilities</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>Develop & Maintain APIs –</span> Build backend services and RESTful APIs using Node.js.</li>
                              <li><span>Write Efficient Code –</span> Create reusable, reliable, and maintainable backend components.</li>
                              <li><span>Integrate with Frontend –</span> Collaborate with frontend developers to ensure smooth integration of UI and backend logic.</li>
                              <li><span>Optimize Performance –</span> Improve application speed, scalability, and security.</li>
                              <li><span>Ensure Quality –</span> Implement automated testing, debugging, and continuous integration workflows.</li>
                              <li><span>Collaborate with Product Teams –</span> Understand business requirements and translate them into technical deliverables.</li>
                              <li><span>Participate in Code Reviews –</span> Share feedback and maintain high coding standards.</li>
                              <li><span>Troubleshoot & Resolve Issues –</span> Diagnose problems, perform root cause analysis, and implement fixes.</li>
                              <li><span>Stay Current –</span> Keep up with emerging backend technologies and best practices.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>Requirements</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>Experience –</span> 0-1 Years as a Backend Developer with Node.js. </li>
                              <li><span>Technical Skills –</span> Strong proficiency in JavaScript and Node.js frameworks (Express.js, Nest.js).</li>
                              <li><span>Database Knowledge –</span> Experience with MongoDB, MySQL, or PostgreSQL.</li>
                              <li><span>API Expertise –</span> Solid understanding of REST API design principles.</li>
                              <li><span>Architecture Skills –</span> Understanding of asynchronous programming and event-driven systems.</li>
                              <li><span>Collaboration Tools –</span> Proficiency with Git and collaborative workflows.</li>
                              <li><span>Soft Skills –</span> Strong problem-solving abilities, attention to detail, and clear communication.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>Preferred Qualifications</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li>Experience with cloud platforms (AWS, Azure, GCP).</li>
                              <li>Knowledge of containerization (Docker) and orchestration (Kubernetes).</li>
                              <li>Familiarity with DevOps practices and CI/CD pipelines.</li>
                              <li>Experience with GraphQL.</li>
                              <li>Open-source contributions or a strong GitHub portfolio.</li>
                            </ul>
                          </div>
                        </div>


                        

                        <p>📩 <span className='fontWeight'>How to Apply:</span> Send your <span className='fontWeight'>résumé</span> and <span className='fontWeight'>portfolio/GitHub profile</span> to <span className='fontWeight'><a href="mailto:careers@mandir.wiki">careers@mandir.wiki</a></span> with the subject line: <span className='fontWeight'>résumé – Backend Developer (Node.js) Intern</span></p>
                        <a href="mailto:careers@mandir.wiki?Backend Developer (Node.js) Intern" className='outlineButton'>Apply Now</a>

                      </Box>

                      <Box className="templeInnerHeading mt-5 ">
                        <h2 className='tealColor'>Product Manager – Mandirwiki Platform</h2>

                        <div className='openingDetails mt-3'>
                          <h6 className="experience"><strong><i className="fa fa-briefcase"></i></strong> Full-Time</h6>
                          <h6 className="experience"><strong><i className="fa fa-inr"></i></strong> Negotiable, 6 Days a week  </h6>
                          <h6 className="experience"><strong><i className="fa fa-laptop"></i></strong> In-office  </h6>
                          <h6 className="location"><strong><i className="fa fa-map-marker"></i></strong> Delhi  </h6>
                        </div>
                      </Box>
                      <Box className="openingBox mt-4">
                        <h3>About the Role</h3>
                        <p className='mb-2'>We’re seeking an <span className='fontWeight'>experienced and visionary Product Manager</span> to take full ownership of the Mandirwiki platform. This is a high-impact leadership role where you’ll define the product vision, lead execution, and drive both user engagement and revenue growth.</p>
                        <p className='mb-2'>You’ll be the <span className='fontWeight'>strategic driver, problem solver, and product evangelist</span> —shaping how millions connect with spiritual experiences through technology.</p>

                        <h3>What You’ll Do</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>Lead Product Strategy & Execution –</span> Own the product roadmap end-to-end, from concept to launch, ensuring alignment with market needs and user expectations.</li>
                              <li><span>Drive User & Revenue Growth -</span> Implement product-led growth strategies and go-to-market plans that directly impact engagement and monetization.</li>
                              <li><span>Lead Cross-Functional Teams –</span> Collaborate closely with engineering, design, and content teams to deliver exceptional releases on time.</li>
                              <li><span>Champion the Product Vision –</span> Act as the internal and external face of the product, ensuring all stakeholders are aligned with goals and progress.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>What We’re Looking For</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>Education:</span> Degree from a Tier-1 institute (IIT, NIT, IIM, or equivalent).</li>
                              <li><span>Experience:</span></li>
                              <li>2+ years in product management.</li>
                              <li>1+ year in OTT, E-commerce, or a content-driven platform (mandatory).</li>
                              <li>Proven track record of managing products through the entire lifecycle.</li>
                              <li>Strong leadership, problem-solving, and communication skills.</li>
                            </ul>
                          </div>
                        </div>



                        <h3>Nice to Have</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li>Experience in <span>0-to-1 startup environments.</span></li>
                              <li>Passion for <span>AR/VR</span> and immersive technologies.</li>
                              <li>Technical background or past hands-on development experience.</li>
                              <li>Exposure to <span>AI tools</span> for productivity and product feature enhancements.</li>
                            </ul>
                          </div>
                        </div>



                        <h3>Why Join Us?</h3>

                        <div className="listCheck">
                          <ul>
                            <li><span>✔ –</span> 	Lead a high-impact product with national and global relevance.</li>
                            <li><span>✔ –</span> 	Shape the future of <span>spiritual tech</span> in India.</li>
                            <li><span>✔ –</span> 	Competitive salary in a rapidly growing startup.</li>
                            <li><span>✔ –</span> 	Be part of a mission-driven team blending <span>innovation with tradition.</span></li>

                          </ul>
                        </div>


                        

                        <p>📩 <span className='fontWeight'>How to Apply:</span> Send your <span className='fontWeight'>résumé</span> to <span className='fontWeight'><a href="mailto:careers@mandir.wiki">careers@mandir.wiki</a></span> with the subject line: <span className='fontWeight'>Résumé</span> –Product Manager (Mandirwiki).</p>
                        <a href="mailto:careers@mandir.wiki? Resume – Product Manager (Mandirwiki)."  className='outlineButton'>Apply Now</a>

                      </Box>
                    </div>


                    <div
                      className="tab-pane fade custom-tab-pane"
                      id="fa"
                      role="tabpanel"
                      aria-labelledby="fa-tab"
                    >
                      <Box className="templeInnerHeading mt-5 ">
                        <h2 className='tealColor'>Payroll Specialist</h2>
                        <div className='openingDetails mt-3'>
                          <h6 className="experience"><strong><i className="fa fa-briefcase"></i></strong> Full-Time</h6>
                          <h6 className="experience"><strong><i className="fa fa-inr"></i></strong> 30,000/month, 6 Days a week</h6>
                          <h6 className="location"><strong><i className="fa fa-map-marker"></i></strong> Remote  </h6>
                        </div>
                      </Box>
                      <Box className="openingBox mt-4">
                        <h3>About the Role</h3>
                        <p className='mb-2'>We’re seeking a <span className='fontWeight'>Payroll Specialist</span> with <span className='fontWeight'>3+ years of experience</span> to take complete ownership of our payroll operations. You’ll be responsible for managing end-to-end payroll processes, ensuring compliance with statutory requirements, maintaining accurate HR data, and driving process automation for efficiency.</p>

                        <h3>What You’ll Do</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>Own the Payroll Process –</span> Accurately calculate salaries, bonuses, deductions, overtime, and payable days while ensuring timely disbursement.</li>
                              <li><span>Ensure Statutory Compliance –</span> Manage TDS, PF, ESIC, and other payroll-related legal requirements.</li>
                              <li><span>Maintain Comprehensive Records –</span> Track leave balances, advances, tax details, and other payroll heads for full transparency.</li>
                              <li><span>Communicate Clearly –</span> Share salary details with employees prior to payout and address payroll-related queries promptly.</li>
                              <li><span>Resolve Discrepancies –</span> Investigate and fix payroll errors while maintaining accuracy and confidentiality.</li>
                              <li><span>Keep Records Compliant –</span> Maintain up-to-date payroll, benefits, and tax deduction data in line with labor laws.</li>
                              <li><span>File Statutory Reports –</span> Prepare and submit payroll-related filings on time to relevant authorities.</li>
                              <li><span>Drive HR Process Improvements –</span> Implement HR automation projects for payroll, attendance tracking, and operational efficiency.</li>
                              <li><span>Support HR Policies –</span> Develop and update HR policies in compliance with tax laws, labor laws, and industry standards.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>What We’re Looking For</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>Experience:</span> 3+ years in payroll management with a strong HR and compliance background.</li>
                              <li><span>Skills:</span> Excellent Excel skills and proficiency in Microsoft Office.</li>
                              <li><span>Qualities:</span> High attention to detail, organizational excellence, and ability to handle confidential data with integrity.</li>
                              <li><span>Knowledge:</span> Strong understanding of statutory compliance in payroll, including PF, ESIC, and tax regulations.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>Why Join Us?</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li>Take complete ownership of a critical function in a fast-growing spiritual-tech organization.</li>
                              <li>Be part of a mission-driven team blending tradition with innovation.</li>
                              <li>Work in an environment that values efficiency, accuracy, and process improvement.</li>
                            </ul>
                          </div>
                        </div>


                        

                        <p>📩 <span className='fontWeight'>How to Apply:</span> Send your <span className='fontWeight'>résumé</span> to <span className='fontWeight'><a href="mailto:careers@mandir.wiki">careers@mandir.wiki</a></span> with the subject line: Résumé –Payroll Specialist.</p>
                        <a href="mailto:careers@mandir.wiki?Payroll Specialist" className='outlineButton'>Apply Now</a>

                      </Box>


                    </div>

                    <div
                      className="tab-pane fade custom-tab-pane"
                      id="creative"
                      role="tabpanel"
                      aria-labelledby="creative-tab"
                    >

                      <Box className="templeInnerHeading mt-5 ">
                        <h2 className='tealColor'>Figma Designer Intern</h2>
                         <div className='openingDetails mt-3'>
                        <h6 className="experience"><strong>Type</strong> Full-Time</h6>
                          <h6 className="experience"><strong>Experience</strong> 0-1 Years</h6>
                          <h6 className="location"><strong><i className="fa fa-map-marker"></i></strong> Remote, 6 Days a week </h6>
                        </div>
                      </Box>
                      <Box className="openingBox mt-4">
                        <h3>About the Role</h3>
                        <p className='mb-2'>We are looking for a <span className='fontWeight'>Figma Designer</span> with a passion for crafting beautiful, user-friendly, and impactful digital experiences. You’ll be responsible for <span className='fontWeight'>designing intuitive UI/UX layouts</span> for web and mobile applications, working closely with product managers, developers, and other stakeholders to bring ideas to life.</p>
                        <p className='mb-2'>This role is perfect for someone who can blend <span className='fontWeight'>creativity with precision,</span> turning wireframes and concepts into pixel-perfect designs that align with brand and business goals.</p>

                        <h3>Responsibilities</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>Design & Prototype –</span> Create wireframes, mockups, and interactive prototypes in Figma for web and mobile apps.</li>
                              <li><span>Collaborate Cross-Functionally –</span> Work with product managers, developers, and marketing teams to translate requirements into designs.</li>
                              <li><span>Maintain Design Consistency –</span> Establish and manage style guides, design systems, and component libraries.</li>
                              <li><span>User-Centric Approach –</span> Apply UI/UX best practices to enhance usability and accessibility.</li>
                              <li><span>Iterate & Improve –</span> Incorporate feedback from stakeholders and users to refine designs.</li>
                              <li><span>Export & Deliver Assets –</span> Prepare and share production-ready assets with developers.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>Requirements</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>Experience –</span> Proven work as a UI/UX or Product Designer with a strong Figma portfolio.</li>
                              <li><span>Figma Mastery –</span> Skilled in creating responsive designs, components, and prototypes.</li>
                              <li><span>Design Principles –</span> Strong understanding of typography, color theory, and layout.</li>
                              <li><span>Collaboration Skills –</span> Comfortable working with cross-functional teams.</li>
                              <li><span>Attention to Detail –</span> Ability to maintain brand consistency while pushing creativity.</li>
                              <li><span>Nice to Have –</span> Familiarity with other design tools like Adobe XD, Photoshop, Illustrator, or motion tools like After Effects.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>Preferred Qualifications</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li>Experience designing for both mobile and web platforms.</li>
                              <li>Knowledge of HTML/CSS basics to communicate better with developers.</li>
                              <li>Familiarity with design systems and component-based workflows.</li>
                            </ul>
                          </div>
                        </div>


                       


                        <p>📩 <span className='fontWeight'>How to Apply:</span> Send your <span className='fontWeight'>résumé, portfolio link,</span> and a short note on your favorite design project to <span className='fontWeight'><a href="mailto:careers@mandir.wiki">careers@mandir.wiki</a></span> with the subject line: <span className='fontWeight'>Résumé – Figma Designer Intern.</span></p>
                        <a href="mailto:careers@mandir.wiki?Figma Designer Intern" className='outlineButton'>Apply Now</a>

                      </Box>
                      <Box className="templeInnerHeading mt-5 ">
                        <h2 className='tealColor'>Creative Lead -Video Innovation and Production</h2>
                        <div className='openingDetails mt-3'>
                          <h6 className="experience"><strong><i className="fa fa-briefcase"></i></strong> Full-Time</h6>
                          <h6 className="experience"><strong>Experiance</strong> 3–5 years exp. | Immediate start preferred</h6>
                          <h6 className="experience"> ₹30K–₹50K/month, 6 Days a week   </h6>
                          <h6 className="location"><strong><i className="fa fa-map-marker"></i></strong> New Delhi  </h6>
                        </div>
                      </Box>
                      <Box className="openingBox mt-4">
                        <h3>About the Role</h3>
                        <p className='mb-2'>We’re seeking a visionary <span className='fontWeight'>Creative Lead</span> to take charge of our video storytelling division. This isn’t a simple “edit videos” role — you’ll architect the creative direction, lead a talented crew, and craft cinematic experiences that resonate with audiences.</p>
                        <p>If you live at the intersection of <span className='fontWeight'>art, technology, and leadership — from stunning motion graphics to AI-powered visual narratives</span> — this role is your stage.</p>

                        <h3>What You’ll Be Driving</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>End-to-End Video Leadership –</span> From brainstorming and scripting to final delivery, you’ll oversee the complete lifecycle.</li>
                              <li><span>Creative Hands-On Work –</span> Edit, animate, and produce professional-grade content using Adobe Premiere Pro & After Effects.</li>
                              <li><span>Team Empowerment –</span> Manage and mentor 2–3 skilled editors, raise the creative bar, and keep morale high.</li>
                              <li><span>Smart Workflow Management –</span> Distribute tasks, manage timelines, and keep production running like clockwork.</li>
                              <li><span>Cross-Team Collaboration –</span> Partner with marketing, content, and design units to turn briefs into captivating visual campaigns.</li>
                              <li><span>Brand Guardianship –</span> Maintain a consistent style and tone across every frame.</li>
                              <li><span>AI-First Production –</span> Experiment with and integrate tools like Midjourney, Runway, Pika, Synthesia, and Veo 3 to innovate and accelerate content creation.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>What Makes You the One</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li>Background – 4–5 years in professional video production, with at least some team leadership or mentoring experience.</li>
                              <li>Core Skills
                                <ul>
                                  <li>Expert in Adobe Premiere Pro & After Effects.</li>
                                  <li>Familiarity with AI-based video creation tools.</li>
                                  <li>Strong eye for pacing, sound design, and visual appeal.</li>
                                </ul>
                              </li>
                              <li><span>Work Ethic –</span> Organized, deadline-driven, and able to juggle multiple projects without compromise.</li>
                              <li><span>Portfolio – </span>Includes both solo work and team-led productions that demonstrate creativity and impact.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>Bonus Points For</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li>	3D animation or VR experience.</li>
                              <li>	Comfort with project management tools (Notion, Jira, Trello, etc.).</li>
                              <li>	Ability to storyboard or write short scripts.</li>
                            </ul>
                          </div>
                        </div>

                        <h3>Why You’ll Love It Here</h3>

                        <div className="listCheck">
                          <ul>
                            <li><span>✔ Lead with Creative Freedom –</span> Shape the visual language of our brand.</li>
                            <li><span>✔ Work on the Cutting Edge –</span> AI-driven content, immersive media, and next-gen tools.</li>
                            <li><span>✔ Direct Impact –</span> See your ideas go live and make an immediate difference.</li>
                            <li><span>✔ Collaborative Energy – </span> A close-knit team that values experimentation and initiative.</li>

                          </ul>
                        </div>


                        

                        <p>📩 <span className='fontWeight'>How to Apply:</span> Send your <span className='fontWeight'>résumé and portfolio  to </span> <span className='fontWeight'><a href="mailto:careers@mandir.wiki">careers@mandir.wiki</a></span> with the subject line: <span className='fontWeight'>Résumé –Lead Creative (Video Innovation)</span> </p>
                        <a href="mailto:careers@mandir.wiki?Video Innovation & Production" className='outlineButton'>Apply Now</a>

                      </Box>

                      <Box className="templeInnerHeading mt-5 ">
                        <h2 className='tealColor'>Sketch Artist – Temple Architecture & Deity Illustration</h2>
                        <div className='openingDetails mt-3'>
                          <h6 className="experience"><strong><i className="fa fa-briefcase"></i></strong> Full-Time</h6>
                          <h6 className="experience"><strong><i className="fa fa-inr"></i></strong> Negotiable, 6 Days a week  </h6>
                          <h6 className="experience"><strong><i className="fa fa-laptop"></i></strong> Remote  </h6>
                          <h6 className="location"><strong><i className="fa fa-map-marker"></i></strong> Delhi  </h6>
                        </div>
                      </Box>
                      <Box className="openingBox mt-4">
                        <h3>About the Role</h3>
                        <p className='mb-2'>We are looking for a <span className='fontWeight'>talented and culturally attuned Sketch Artist</span> to bring India’s sacred spaces to life through <span className='fontWeight'>high-precision, culturally authentic illustrations.</span> Your work will help devotees experience the architectural grandeur and divine presence of temples in a way that’s visually stunning and spiritually respectful.</p>
                        <p className='mb-2'>This isn’t just an art role — it’s a <span className='fontWeight'>cultural preservation mission.</span> You’ll collaborate with historians, scholars, designers, and VR developers to ensure every line you draw honors tradition while captivating modern audiences.</p>

                        <h3>What You’ll Do</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>Bring Temples to Paper (and Screens):</span> Create intricate, hand-drawn and digital sketches of temple architecture, deities, and sacred motifs.</li>
                              <li><span>Capture Cultural Authenticity:</span> Work with religious scholars and internal experts to ensure every depiction respects traditional symbolism, mudras, ornaments, and sacred geometry.</li>
                              <li><span>Blend Art with Technology:</span> Adapt your sketches for use in AR/VR experiences, mobile apps, and print, ensuring they retain detail and impact across formats.</li>
                              <li><span>Do the Groundwork:</span> Conduct site visits and in-depth research to capture authentic architectural details, deity attributes, and regional design elements.</li>
                              <li><span>Collaborate Across Teams:</span> Work closely with content writers, researchers, UI/UX designers, and VR developers to integrate artwork seamlessly into digital experiences.</li>
                              <li><span>Maintain Your Knowledge Bank:</span> Build and organize a reference library of authentic symbols, architectural elements, and visual styles for future projects.</li>
                              <li><span>Deliver with Precision:</span> Meet deadlines without compromising on the level of detail or cultural accuracy.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>What We’re Looking For</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>Artistic Expertise:</span> Proven experience as a sketch artist, illustrator, or visual designer, preferably with a focus on heritage, religious, or cultural subjects.</li>
                              <li><span>Cultural Sensitivity:</span> Deep understanding of Indian temple architecture and iconography across various traditions and regions.</li>
                              <li><span>Technical Skills:</span> Proficiency in both hand-drawing and digital tools (Adobe Illustrator, Photoshop, Procreate, etc.).</li>
                              <li><span>Attention to Detail:</span> Ability to translate spiritual and cultural nuances into visually precise and respectful artwork.</li>
                              <li><span>Collaborative Spirit:</span> Comfortable working with cross-functional teams and open to feedback.</li>
                              <li><span>Field Readiness:</span> Willingness to travel for field studies, site documentation, and first-hand reference gathering.</li>
                              <li><span>Educational Background:</span> Degree or diploma in Fine Arts, Visual Design, Architecture, or related field is a plus.</li>
                            </ul>
                          </div>
                        </div>







                        <h3>Why You’ll Love It Here</h3>

                        <div className="listCheck">
                          <ul>
                            <li><span>✔ –</span> 	Your work will preserve and share India’s spiritual heritage with millions worldwide.</li>
                            <li><span>✔ –</span> 	You’ll collaborate with passionate, mission-driven professionals in art, tech, and culture.</li>
                            <li><span>✔ –</span> 	You’ll collaborate with passionate, mission-driven professionals in art, tech, and culture.</li>
                            <li><span>✔ –</span> 	You’ll be part of a fast-growing spiritual-tech movement that values authenticity as much as innovation.</li>

                          </ul>
                        </div>


                        


                        <p>📩 <span className='fontWeight'>How to Apply:</span> Send your <span className='fontWeight'>résumé,</span> portfolio, and a short note on your favourite temple artwork (and why it inspires you) to <a href="mailto:careers@mandir.wiki">careers@mandir.wiki</a> with the subject line: <span className='fontWeight'>Résumé – Sketch Artist.</span></p>
                        <a href="mailto:careers@mandir.wiki?Sketch Artist – Temple Architecture & Deity Illustration" className='outlineButton'>Apply Now</a>

                      </Box>
<Box className="templeInnerHeading mt-5 ">
                        <h2 className='tealColor'>AI Content Creator</h2>
                        <div className='openingDetails mt-3'>
                          <h6 className="experience"><strong><i className="fa fa-briefcase"></i></strong> Full-Time</h6>
                          <h6 className="experience"><strong><i className="fa fa-inr"></i></strong> Negotiable, 6 Days a week</h6>
                          <h6 className="location"><strong><i className="fa fa-map-marker"></i></strong> New Delhi  </h6>
                        </div>
                      </Box>
                      <Box className="openingBox mt-4">
                        <h3>About the Role</h3>
                        <p>We’re looking for a creative mind who can turn AI tools into storytelling powerhouses. You’ll work with platforms like <span className='fontWeight'>RunwayML, Sora, Midjourney, Veo3</span> and more to create content that not only looks stunning but spreads fast. You’ll manage the entire process from dreaming up ideas to publishing content that people can’t help but share.</p>

                        <h3>Your Day-to-Day</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li>Create scroll-stopping visuals for Instagram, Facebook, and other social media.</li>
                              <li>Transform AI-generated images and videos into polished, professional content.</li>
                              <li>Plan and run campaigns that build engagement and reach.</li>
                              <li>Experiment with the newest AI tools and social features before they hit the mainstream.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>What You Bring</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li>At least 2 AI-generated Reels or posts that crossed 1- 1.5M+ views.</li>
                              <li>Hands-on experience with RunwayML, Sora, Midjourney, Veo3, or similar AI platforms.</li>
                              <li>Strong skills in video and image editing using Adobe Creative Suite or similar.</li>
                              <li>A knack for storytelling that turns concepts into memorable visuals.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>Nice to Have</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li>Experience in tech, art, or immersive AR/VR projects.</li>
                              <li>Advanced video editing and graphic design skills.</li>
                            </ul>
                          </div>
                        </div>

                        <h3>Why Work with Us</h3>

                        <div className="listCheck">
                          <ul>
                            <li><span>✔ -</span> Be part of a mission-driven team blending tradition with cutting-edge tech.</li>
                            <li><span>✔ -</span> Work on content that reaches millions of people worldwide.</li>
                            <li><span>✔ -</span> Build a standout portfolio with high-visibility projects.</li>

                          </ul>
                        </div>


                        

                        <p>📩 <span className='fontWeight'>How to Apply:</span> Email your résumé and portfolio to <span className='fontWeight'><a href="mailto:careers@mandir.wiki">careers@mandir.wiki</a></span> with the subject line <span className='fontWeight'>“Résumé – AI Content Creator”. </span>  Include direct links to your AI posts with 1M+ views.</p>
                        <a href="mailto:careers@mandir.wiki?AI Content Creator" className='outlineButton'>Apply Now</a>

                      </Box>
<Box className="templeInnerHeading mt-5 ">
                        <h2 className='tealColor'>Content Creator -Intern</h2>
                        <div className='openingDetails mt-3'>
                          <h6 className="experience"><strong><i className="fa fa-briefcase"></i></strong> Remote </h6>
                          <h6 className="experience"><strong><i className="fa fa-inr"></i></strong> 20K/month, 6 Days a week </h6>
                          <h6 className="location"><strong><i className="fa fa-map-marker"></i></strong> Delhi  </h6>
                        </div>
                      </Box>
                      <Box className="openingBox mt-4">
                        <h3>About the Role</h3>
                        <p className='mb-2'><span className='fontWeight'>Important:</span> If you don’t actively create content on your social media and can’t share a personal portfolio, this role is not for you. We want creators who live and breathe content.</p>

                        <h3>Your Role & Impact</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>Create Compelling Content –</span> Develop engaging material for social media, blogs, websites, and marketing campaigns.</li>
                              <li><span>Support Content Strategy –</span> Assist in planning and executing creative content initiatives.</li>
                              <li><span>Research & Trend Spotting –</span> Identify trending topics, keywords, and industry themes to keep content fresh and relevant.</li>
                              <li><span>Write Across Formats –</span> Produce captions, short articles, scripts, and ideas for visual storytelling.</li>
                              <li><span>Leverage AI Tools –</span> Use platforms like ChatGPT, Copy.ai, or Notion AI to brainstorm, draft, and refine content ideas.</li>
                              <li><span>Collaborate Creatively –</span> Work with design and marketing teams to ensure all content aligns with brand tone and objectives.</li>
                              <li><span>Analyze & Improve –</span> Monitor content performance and suggest optimizations for better reach and engagement.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>What We’re Looking For</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>Growth Mindset –</span> Openness to learning, taking feedback, and adapting quickly.</li>
                              <li><span>Strong Communication Skills –</span> Excellent writing in both Hindi and English, editing, and verbal communication abilities.</li>
                              <li><span>Social Media Know-How –</span> Basic understanding of platforms like Instagram, LinkedIn, and Twitter.</li>
                              <li><span>Creative Storytelling –</span> A natural flair for crafting engaging narratives.</li>
                              <li><span>AI Literacy –</span> Hands-on experience with AI tools (ChatGPT, Copy.ai, Notion AI, or similar).</li>
                              <li><span>Additional Skills –</span> Familiarity with Canva, Grammarly, Google Docs, or similar productivity/design tools.</li>
                              <li><span>Preferred Background –</span> Degree/diploma in English, Mass Communication, Marketing, or a related field.</li>
                            </ul>
                          </div>
                        </div>




                        <h3>Why You’ll Love It Here</h3>

                        <div className="listCheck">
                          <ul>
                            <li><span>✔ –</span> Blend tradition with innovation in every piece of content.</li>
                            <li><span>✔ –</span> Enjoy creative freedom while making an impact on a purpose-driven brand.</li>
                            <li><span>✔ –</span> Be part of a fast-growing company with a one-of-a-kind niche.</li>

                          </ul>
                        </div>


                        

                        <p>📩 <span className='fontWeight'>How to Apply:</span> Send your <span className='fontWeight'>résumé</span> and <span className='fontWeight'>links to your social profiles & portfolio</span> to <span className='fontWeight'><a href="mailto:careers@mandir.wiki">careers@mandir.wiki</a></span> with the subject: <span className='fontWeight'>Résumé – Content Creator -Intern.</span></p>
                        <a href="mailto:careers@mandir.wiki?Content Creator -Intern" className='outlineButton'>Apply Now</a>

                      </Box>
                      
                    </div>

                    <div
                      className="tab-pane fade custom-tab-pane"
                      id="bde"
                      role="tabpanel"
                      aria-labelledby="bde-tab"
                    >
                      <Box className="templeInnerHeading mt-5 ">
                        <h2 className='tealColor'>Regional Lead – Temple Partnerships</h2>

                        <div className='openingDetails mt-3'>
                          <h6 className="experience"><strong><i className="fa fa-briefcase"></i></strong> Full-Time</h6>
                          <h6 className="experience">₹75k – ₹90k/month + Incentives, 6 Days a week</h6>
                          <h6 className="location"><strong><i className="fa fa-map-marker"></i></strong> Regional Zone Based (Multiple States)  </h6>
                        </div>
                      </Box>
                      <Box className="openingBox mt-4">
                        <h3>About the Role</h3>
                        <p className='mb-2'>We’re looking for a <span className='fontWeight'>strategic and well-connected Regional Lead</span> to lead temple partnerships in your assigned region. This is a <span className='fontWeight'>high-visibility leadership role</span> where you’ll be the face of Mandirwiki in front of temple boards, trust members, and government authorities.</p>
                        <p className='mb-2'>You’ll <span className='fontWeight'>build relationships, close strategic partnerships, and guide your team</span> in rolling out our technological solutions across prominent temples. Your work will directly shape how millions of devotees experience darshan in the coming years.</p>

                        <h3>What You’ll Do</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>Lead Partnerships End-to-End –</span> From prospecting to signing MOU and overseeing on-ground execution.</li>
                              <li><span>Engage with Key Decision Makers –</span> Build trust with temple boards, administrative authorities, and state/local government officials.</li>
                              <li><span>Represent Mandirwiki –</span> Attend high-level meetings, religious tourism events, and cultural forums as our regional ambassador.</li>
                              <li><span>Lead Your Team –</span> Mentor Business Development Executives, monitor performance, and ensure sales and partnership targets are met.</li>
                              <li><span>Plan & Execute Expansion –</span> Develop region-specific outreach strategies aligned with cultural sensitivities.</li>
                              <li><span>Coordinate Internally –</span> Work with operations, content, and tech teams to ensure smooth project execution.</li>
                              <li><span>Report & Forecast –</span> Maintain accurate records, generate performance reports, and use data for decision-making.</li>
                              <li><span>Travel Across the Region –</span> Visit temples, attend meetings, and build on-the-ground relationships.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>What We’re Looking For</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li>5+ years in business development, government/temple liaisoning, or institutional partnerships.</li>
                              <li>Proven success in working with temple authorities, spiritual tourism boards, or religious institutions.</li>
                              <li>Strong leadership, negotiation, and networking skills.</li>
                              <li>Excellent communication in Hindi, English, and the regional language.</li>
                              <li>Comfortable with extensive regional travel.</li>
                              <li>Deep understanding of India’s religious and cultural landscape, with high respect for spiritual values.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>Perks & Benefits</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li>Performance-based incentives up to ₹50,000/month.</li>
                              <li>Leadership role in a high-impact pilgrimage-tech initiative.</li>
                              <li>Opportunities to grow with a fast-scale startup.</li>
                              <li>Work that blends technology, tradition, and purpose.</li>
                            </ul>
                          </div>
                        </div>


                        

                        <p>📩 <span className='fontWeight'>How to Apply</span>: Send your <span className='fontWeight'>résumé</span> to <span className='fontWeight'><a href="mailto:careers@mandir.wiki">careers@mandir.wiki</a></span> with the subject line: <span className='fontWeight'>Résumé</span> – Regional Lead (Temple Partnerships).</p>
                        <a href="mailto:careers@mandir.wiki?Regional Lead – Temple Partnerships" className='outlineButton'>Apply Now</a>

                      </Box>
                      <Box className="templeInnerHeading mt-5 ">
                        <h2 className='tealColor'>Field Sales Executive</h2>
                        <div className='openingDetails mt-3'>
                          <h6 className="experience"><strong><i className="fa fa-briefcase"></i></strong> Full-Time, 6 Days a week</h6>
                          <h6 className="location"><strong><i className="fa fa-map-marker"></i></strong> Delhi  </h6>
                        </div>
                      </Box>
                      <Box className="openingBox mt-4">
                        <h3>About the Role</h3>
                        <p className='mb-2'>We’re looking for an <span className='fontWeight'>energetic, persuasive, and goal-driven Field Sales Executive</span> to help us take our <span>Smart Lockers and VR</span> across India. If you love meeting people, building relationships, and turning conversations into sales, this role is for you</p>

                        <h3>What You’ll Do</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li>Visit and connect with <span>temple trusts, railways, and bureaucrats</span> to promote and sell our smart <span>lockers</span> and <span>VR</span> product.</li>
                              <li>Scout the market to <span>find and approach potential leads</span> through on-ground visits.</li>
                              <li><span>Showcase and demonstrate</span> product features, explaining how they can benefit the vendor’s business.</li>
                              <li>Build <span>long-term relationships</span> for repeat sales.</li>
                              <li>Consistently <span>achieve weekly and monthly sales targets.</span></li>
                              <li>Gather <span>market insights</span> and share feedback with the team.</li>
                              <li>Maintain a <span>daily log</span> of visits, conversations, and outcomes.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>What We’re Looking For</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>1–3</span> years of field sales experience (motivated freshers are welcome to apply).</li>
                              <li>Based in or willing to work full-time in <span>New Delhi.</span></li>
                              <li>Excellent <span>communication and negotiation skills.</span></li>
                              <li>Comfortable with <span>extensive travel</span> within the city.</li>
                              <li>Self-motivated, target-oriented, and resilient.</li>
                              <li>Bonus if you know the <span>local market and vendor network.</span></li>
                            </ul>
                          </div>
                        </div>


                        <h3>Why Join Us?</h3>

                        <div className="listCheck">
                          <ul>
                            <li><span>✔ –</span> 	Work on an innovative product that’s redefining spiritual engagement.</li>
                            <li><span>✔ –</span> 	Be part of a <span>fast-growing, mission-driven startup.</span></li>
                            <li><span>✔ –</span> 	Build meaningful relationships while growing your career in sales.</li>

                          </ul>
                        </div>


                        

                        <p>📩 <span className='fontWeight'>How to Apply:</span> Send your <span className='fontWeight'>résumé</span> to <span className='fontWeight'><a href="mailto:careers@mandir.wiki">careers@mandir.wiki</a></span> with the subject line: <span className='fontWeight'>Résumé</span> – Field Sales Executive.</p>
                        <a href="mailto:careers@mandir.wiki?Field Sales Executive" className='outlineButton'>Apply Now</a>

                      </Box>
    
                    </div>

                    <div
                      className="tab-pane fade custom-tab-pane"
                      id="writer"
                      role="tabpanel"
                      aria-labelledby="writer-tab"
                    >
                     <Box className="templeInnerHeading mt-5 ">
                        <h2 className='tealColor'>Storyteller & Script Writer</h2>
                        <div className='openingDetails mt-3'>
                          <h6 className="experience"><strong><i className="fa fa-briefcase"></i></strong> Full-Time</h6>
                          <h6 className="experience"><strong>Work Type</strong> Remote</h6>
                          <h6 className="experience"><strong><i className="fa fa-inr"></i></strong> Negotiable, 6 Days a week</h6>
                          <h6 className="location"><strong><i className="fa fa-map-marker"></i></strong> New Delhi  </h6>
                        </div>
                      </Box>
                      <Box className="openingBox mt-4">
                        <h3>About the Role</h3>
                        <p className='mb-2'>As our <span className='fontWeight'>Storyteller & Content Writer,</span> you’ll transform <span className='fontWeight'>research, rituals, and legends</span> into captivating narratives that guide our cinematographers and immerse our audience. Your words will breathe life into centuries-old traditions while keeping them relatable for today’s viewers.</p>
                        <p>If you live and breathe <span className='fontWeight'>storytelling, cultural heritage, and emotional connection,</span> this is your canvas.</p>

                        <h3>What You’ll Do</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li>Research and write scripts that tell the stories of various temples, highlighting their historical, spiritual, and cultural significance.</li>
                              <li>Collaborate with the cinematographer to ensure your scripts translate into powerful visual storytelling.</li>
                              <li><span>Think Creatively –</span> Contribute ideas in brainstorming sessions to enhance storytelling impact.</li>
                              <li><span>Deliver with Precision –</span> Meet deadlines while upholding high standards of research and writing.</li>
                              <li><span>Keep the Brand Voice –</span> Ensure all content aligns with Mandirwiki’s inspiring, respectful, and informative tone.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>What We’re Looking For</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li><span>Bilingual Brilliance –</span> Strong writing skills in both Hindi and English.</li>
                              <li><span>Cultural Sensitivity –</span> Deep knowledge of India’s spiritual diversity, festivals, and storytelling traditions.</li>
                              <li><span>Proven Experience –</span> Background in writing, storytelling, or content creation (preferably spiritual/cultural/documentary).</li>
                              <li><span>Collaborative Spirit –</span> Able to work fluidly with cinematographers, editors, and creative teams.</li>
                              <li><span>Creative Clarity –</span> Ability to simplify complex subjects without losing authenticity.</li>
                              <li><span>Bonus Points –</span> Familiarity with video production processes and script formatting.</li>
                            </ul>
                          </div>
                        </div>


                        <h3>Why This Role Matters</h3>
                        <div className='infoGuideBox'>
                          <div className="infoList">
                            <ul>
                              <li>Your stories will define how millions connect with India’s spiritual heritage.</li>
                              <li>You’ll help preserve sacred traditions in a way that inspires future generations.</li>
                              <li>You’ll be part of a mission where creativity serves culture.</li>
                            </ul>
                          </div>
                        </div>




                        

                        <p>📩 <span className='fontWeight'>How to Apply:</span> Send your <span className='fontWeight'>résumé</span> a short cover note, and <span className='fontWeight'>at least two writing samples </span> (preferably cultural or storytelling work) to <span className='fontWeight'><a href="mailto:careers@mandir.wiki">careers@mandir.wiki</a></span> with the subject line: <span className='fontWeight'>Résumé – Storyteller & Script Writer</span></p>
                        <a href="mailto:careers@mandir.wiki?Storyteller & Script Writer" className='outlineButton'>Apply Now</a>

                      </Box>

                      
    
                    </div>


                    
                  </div>
                </div>


                
              </Box>




              
            </Grid>

            {/* <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
              <Box className="openingBox">
                  <h3>Travel Operation - Executive</h3>
                  <p>Should possess impeccable negotiation and internaional skills along with sound knowledge and history in the field of online bookings of hotels, flights, tours etc. - 1 year and Above</p>
                  <div className='openingDetails'>
                  <span className="experience"><strong>Experience:</strong> 2 years & above</span>
                  <span className="location"><strong>Location:</strong> Delhi</span>
                  </div>
                  <a href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#careerModal" className='outlineButton'>Apply Now</a>

              </Box>
            </Grid>

            <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
              <Box className="openingBox">
                  <h3>Travel Operation - Executive</h3>
                  <p>Should possess impeccable negotiation and internaional skills along with sound knowledge and history in the field of online bookings of hotels, flights, tours etc. - 1 year and Above</p>
                  <div className='openingDetails'>
                  <span className="experience"><strong>Experience:</strong> 2 years & above</span>
                  <span className="location"><strong>Location:</strong> Delhi</span>
                  </div>
                  <a href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#careerModal" className='outlineButton'>Apply Now</a>

              </Box>
            </Grid>

            <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
              <Box className="openingBox">
                  <h3>Travel Operation - Executive</h3>
                  <p>Should possess impeccable negotiation and internaional skills along with sound knowledge and history in the field of online bookings of hotels, flights, tours etc. - 1 year and Above</p>
                  <div className='openingDetails'>
                  <span className="experience"><strong>Experience:</strong> 2 years & above</span>
                  <span className="location"><strong>Location:</strong> Delhi</span>
                  </div>
                  <a href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#careerModal" className='outlineButton'>Apply Now</a>

              </Box>
            </Grid>

            <Grid size={{ xl: 6, lg: 6, md: 6, sm: 12, xs: 12 }} >
              <Box className="openingBox">
                  <h3>Travel Operation - Executive</h3>
                  <p>Should possess impeccable negotiation and internaional skills along with sound knowledge and history in the field of online bookings of hotels, flights, tours etc. - 1 year and Above</p>
                  <div className='openingDetails'>
                  <span className="experience"><strong>Experience:</strong> 2 years & above</span>
                  <span className="location"><strong>Location:</strong> Delhi</span>
                  </div>
                  <a href="javascript:void(0)" data-bs-toggle="modal" data-bs-target="#careerModal" className='outlineButton'>Apply Now</a>

              </Box>
            </Grid> */}
          </Grid>
        </Container>
      </section>


      <div className="apply-box container mb-5">
        <div className="apply-card text-center shadow-lg mb-5">
          <h5 className="title"> How To Apply</h5>
          <p className="desc">
            Send your <strong>résumé</strong> to
            <a href="mailto:careers@mandir.wiki" className="email-link">
              {" "}
              careers@mandir.wiki
            </a>
          </p>

          <a
            href="mailto:careers@mandir.wiki"
            className="btn-apply"
          >
            Apply Now
          </a>
        </div>
      </div>



      <div className="modal fade career-modal" id="careerModal" tabindex="-1" aria-labelledby="careerModalLabel" aria-hidden="true">
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">


            <div className="modal-header">
              <h5 className="modal-title" id="careerModalLabel">Send Your Resume Now</h5>
              <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>


            <div className="modal-body">
              <p className="mb-4">Make a start to an incredible career</p>
              <form id="careerForm">
                <div className="mb-3">
                  <label htmlFor="applicantName">Applicant Name</label>
                  <input type="text" className="form-control" id="applicantName" placeholder="Applicant Name" required />
                </div>
                <div className="mb-3">
                  <label htmlFor="jobTitle">Resume Title</label>
                  <input type="text" className="form-control" id="jobTitle" placeholder="Enter Title" required />
                </div>
                <div className="row g-2 mb-3">
                  <div className="col">
                    <label htmlFor="yearsOfExperience">Years of Experience</label>
                    <input type="number" className="form-control" id="yearsOfExperience" placeholder="Years of Experience" required />
                  </div>
                  <div className="col">
                    <label htmlFor="noticePeriod">Notice Period</label>
                    <select className="form-select" id="noticePeriod" required>
                      <option selected disabled>Notice Period</option>
                      <option>Immediate</option>
                      <option>15 Days</option>
                      <option>30 Days</option>
                      <option>60 Days</option>
                    </select>
                  </div>
                </div>
                <div className="row g-2 mb-3">
                  <div className="col">
                    <label htmlFor="currentCTC">Current CTC</label>
                    <input type="text" className="form-control" id="currentCTC" placeholder="Enter CTC" required />
                  </div>
                  <div className="col">
                    <label htmlFor="expectedCTC">Expected CTC</label>
                    <input type="text" className="form-control" id="expectedCTC" placeholder="Enter CTC" required />
                  </div>
                </div>
                <div className="mb-3">
                  <label htmlFor="whyHireYou">Description</label>
                  <textarea className="form-control" id="whyHireYou" rows="3" placeholder="Why should we hire you?" required></textarea>
                </div>
                <div className="mb-3">
                  <label className="form-label" htmlFor="cvUpload">Upload your CV</label>
                  <input type="file" className="form-control" id="cvUpload" required />
                </div>
                <div>
                  <a href="thanks" className="btn-lightGreen w-100 d-block text-center">Submit Resume</a>
                </div>
              </form>
            </div>

          </div>
        </div>
      </div>


    </>
  );
}
export default Career;